import { Cancel, Tag } from "@mui/icons-material";
import { Chip, FormControl, Stack, Grid, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useRef, useState } from "react";

const Tags = ({ data, handleDelete }) => {
    return (
        <Box
            sx={{

                height: "100%",
                display: "flex",
                padding: "0.4rem",
                margin: "0 0.5rem 0 0",
                justifyContent: "center",
                alignContent: "center",
            }}
        >
            <Chip label={data} onClick={() => handleDelete(data)} onDelete={() => handleDelete(data)} />
        </Box>
    );
};

export default function RedQuickInputTags(props: {
    onUpdate: (data: any) => void,
    value: any
}) {
    const [tags, SetTags] = useState([]);
    const tagRef: any = useRef();

    const handleDelete = (value) => {
        const newtags = tags.filter((val) => val !== value);
        SetTags(newtags);
        if (props.onUpdate) {
            props.onUpdate(newtags);
        }
    };
    const handleOnSubmit = (e) => {
        e.preventDefault();
        SetTags([...tags, tagRef?.current?.value]);
        if (props.onUpdate) {
            props.onUpdate([...tags, tagRef?.current?.value]);
        }
        if (tagRef.current) {
            tagRef.current.value = "";
        }
    };
    useEffect(() => {
        SetTags(props.value || []);
    }, [JSON.stringify(props.value || [])])
    return (
        <Box sx={{ p: 2 }}>
            <Grid item xs={12}>
                <Box sx={{ flexGrow: 1 }}>
                    <form onSubmit={handleOnSubmit}>
                        <Box sx={{
                            margin: "0 0.2rem 0 0",
                            display: "flex",
                            flexWrap: 'wrap'
                        }}>
                            {tags.map((data, index) => {
                                return (
                                    <Tags data={data} handleDelete={handleDelete} key={index} />
                                );
                            })}
                        </Box>
                        <TextField
                            inputRef={tagRef}
                            fullWidth
                            variant='standard'
                            size='small'
                            sx={{ margin: "1rem 0" }}
                            margin='none'
                            placeholder={tags.length < 5 ? "Enter tags" : ""}
                        />
                    </form>
                </Box>
            </Grid>
        </Box>
    );
}
